'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createIconComponent = require('./utils/createIconComponent');

var _createIconComponent2 = _interopRequireDefault(_createIconComponent);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconMonitorShoppingCart = (0, _createIconComponent2.default)({ fillContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M24 2.59A2.548 2.548 0 0021.5 0h-19A2.548 2.548 0 000 2.59V16.5a3 3 0 003 3h7.25a.25.25 0 01.25.25v2a.25.25 0 01-.25.25H5a1 1 0 000 2h14a1 1 0 000-2h-6.25a.25.25 0 01-.25-.25v-2a.25.25 0 01.25-.25H21a3 3 0 003-3zM2.5 15a.5.5 0 01-.5-.5V2.59A.551.551 0 012.5 2h19a.551.551 0 01.5.589V14.5a.5.5 0 01-.5.5z' }),
    _react2.default.createElement('path', { d: 'M8.973 9.912a1.248 1.248 0 001.148.756H13.7a1.242 1.242 0 001.165-.8l1.88-4.668a.75.75 0 10-1.391-.561L15 5.511a.248.248 0 01-.231.157H9.05A1.25 1.25 0 007.9 7.41z' }),
    _react2.default.createElement('circle', { cx: '10.55', cy: '12.168', r: '1' }),
    _react2.default.createElement('path', { d: 'M13.3 11.168a1 1 0 101 1 1 1 0 00-1-1z' })
  ), lightContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M10.071 11.5a.998.998 0 01-.917-.6L8.069 7.868a.972.972 0 01-.002-.733.995.995 0 01.931-.635h6.106l.426-1.171a.502.502 0 01.64-.299.497.497 0 01.3.642l-.54 1.486a.381.381 0 01-.016.042l-1.324 3.644a1.002 1.002 0 01-.94.658h-3.579zm3.579-1l1.091-3H8.998l1.073 2.998 3.579.002z' }),
    _react2.default.createElement('circle', { cx: '10.75', cy: '12.75', r: '.75' }),
    _react2.default.createElement('circle', { cx: '13.25', cy: '12.75', r: '.75' }),
    _react2.default.createElement('path', { d: 'M5 22.504a.5.5 0 010-1h6v-1H2c-1.103 0-2-.897-2-2v-15c0-1.103.897-2 2-2h20c1.103 0 2 .897 2 2v15c0 1.103-.897 2-2 2H12v1h7a.5.5 0 010 1H5zm-4-4c0 .552.449 1 1 1h20a1 1 0 001-1v-2H1v2zm22-3v-12c0-.551-.448-1-1-1H2c-.551 0-1 .449-1 1v12h22z' })
  ), regularContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M8.25 22.503a.75.75 0 010-1.5h3v-1.5h-9A2.252 2.252 0 010 17.253v-15A2.252 2.252 0 012.25.003h1.5a.75.75 0 010 1.5h-1.5a.75.75 0 00-.75.75v12h21v-12a.75.75 0 00-.75-.75h-1.5a.75.75 0 010-1.5h1.5A2.252 2.252 0 0124 2.253v15a2.252 2.252 0 01-2.25 2.25h-9v1.5h3a.75.75 0 010 1.5h-7.5zm-6.75-5.25c0 .414.336.75.75.75h19.5a.75.75 0 00.75-.75v-1.5h-21v1.5z' }),
    _react2.default.createElement('path', { d: 'M9 9.753a.75.75 0 01-.712-.513l-1.5-4.5a.752.752 0 01.712-.987h8.292l.74-2.466a.754.754 0 01.935-.503.748.748 0 01.502.933l-2.25 7.5a.747.747 0 01-.719.536H9zm5.442-1.5l.9-3H8.541l1 3h4.901z' }),
    _react2.default.createElement('circle', { cx: '9.375', cy: '11.628', r: '1.125' }),
    _react2.default.createElement('circle', { cx: '14.625', cy: '11.628', r: '1.125' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconMonitorShoppingCart.displayName = 'IconMonitorShoppingCart';
exports.default = IconMonitorShoppingCart;